module.exports = __webpack_public_path__ + "static/img/level-card-banner1.03a55f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/level-card-banner1.png
// module id = xfK1
// module chunks = 1